import { PageType } from 'Shared/State';
import { componentNames } from 'Shared/component-registry';
import CategoryViewModelType from './CategoryViewModel.type';

type CategoryPageType = CategoryViewModelType & PageType;

export default (currentPage: PageType): currentPage is CategoryPageType => {
  return currentPage.componentName === componentNames.Avensia_Common_Features_Category_CategoryViewModel;
};
